import React, { createContext, useContext, useEffect, useState } from "react";
import ManageOrganization from "../components/sections/front/manage-organization/ManageOrganization";
import LoadingFallback from "../components/elements/LoadingFallback";

const OrganizationContext = createContext();

export const OrganizationProvider = ({
  children,
  organizations = [],
  selectedOrganization,
  loading = true,
}) => {
  return (
    <OrganizationContext.Provider
      value={{
        organizations: organizations,
        selectedOrganization: selectedOrganization,
      }}
    >
      {loading ? (
        <LoadingFallback />
      ) : organizations && organizations?.length > 0 ? (
        children
      ) : (
        organizations && organizations?.length === 0 && <ManageOrganization />
      )}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = () => useContext(OrganizationContext);
